// extracted by mini-css-extract-plugin
export var label = "_gf-2";
export var slideContainer = "_gf-0";
export var slider = "_gf-1";